module.exports = __webpack_public_path__ + "static/img/medium_logo5.d04d516.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer/medium_logo5.png
// module id = Ev3t
// module chunks = 11